<div class="table-wrapper h-100">
  <ui-dataset-table
    [data]="tableDataSig()"
    [config]="tableConfig()"
    (rowAction)="onRowAction($event)">
    
    <ng-template #edgeCardTemplate let-row="row">
      <div class="edge-card-info">
        <button type="button" class="info-button" (click)="openCoreInfoModal(row)">
          <mat-icon svgIcon="info"></mat-icon>
          <span>{{ selectAllEdgesSig()[row.edgeId]?.name }}</span>
        </button>
      </div>
    </ng-template>

    <ng-template #edgeHeader let-row="row">
      <div class="edge-group">
        <div class="core-header">
          <div class="flex-row start-center">
            <img src="assets/devices/core.png" alt="Core" />
            <div uiTruncateText>{{ selectAllEdgesSig()[row.edgeId]?.name }}</div>
          </div>
          <div class="flex-row start-center gap-8">
            <mat-icon [svgIcon]="row.eth0connected ? 'cable-connected' : 'cable-disconnected'"></mat-icon>
            <div>
              {{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.ETHERNET' | translate : {
                number: 1,
                speed: row.eth0connected ? (row.eth0speed + ' Mbps') : '—'
              } }}
            </div>
          </div>
          <div class="flex-row start-center gap-8">
            <mat-icon [svgIcon]="row.eth1connected ? 'cable-connected' : 'cable-disconnected'"></mat-icon>
            <div>
              {{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.ETHERNET' | translate : {
                number: 2,
                speed: row.eth1connected ? (row.eth1speed + ' Mbps') : '—'
              } }}
            </div>
          </div>
          <div class="flex-row start-center gap-8">
            <span class="ui-icon-status-online"></span>
            <div>
              {{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.TOTAL_LOAD' | translate : {
                total: row.totalLoad | number : '1.0-2'
              } }}
            </div>
          </div>
        </div>
        <div class="mobile-core-info">
          <button type="button" class="info-button" (click)="openCoreInfoModal(row)">
            <mat-icon svgIcon="info"></mat-icon>
            <span>{{ selectAllEdgesSig()[row.edgeId]?.name }}</span>
          </button>
        </div>
        <div class="camera-header-grid">
          <div class="stream-labels">
            <div></div>
            <div class="stream-label stream-label-main">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.MAIN_STREAM' | translate }}</div>
            <div class="stream-label stream-label-sub">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.SUB_STREAM' | translate }}</div>
            <div></div>
            <div></div>
          </div>
          <div class="camera-header">
            <div class="header-cell">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.CAMERA' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.RESOLUTION' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.FPS' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.CODEC' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.BITRATE' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.DROP' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.RESOLUTION' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.FPS' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.CODEC' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.BITRATE' | translate }}</div>
            <div class="header-cell header-cell-alt">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.DROP' | translate }}</div>
            <div class="header-cell">{{ 'TEST_SELECTED_CAMERA_DIALOG.TABLE.LOAD' | translate }}</div>
            <div class="header-cell"></div>
          </div>
        </div>
      </div>
    </ng-template>
    
    <ng-template #cameraCell let-row>
      <div class="camera-row-cell flex-row start-center gap-8">
        <div class="camera-snapshot">
          <ui-camera-snapshot [cameraId]="row.cameraId"></ui-camera-snapshot>
        </div>
        <div uiTruncateText>{{ selectAllCamerasSig()[row.cameraId]?.edgeOnly?.name }}</div>
      </div>
    </ng-template>

    <ng-template #mainBitrateCell let-row>
      <div class="flex-row start-center gap-4">
        @if (row.mainStream?.bitrate !== null) {
          <span class="ui-icon-status-online"></span>
        }
        <div>{{ row.mainStream?.bitrate !== null ? (row.mainStream?.bitrate | number : '1.0-1') : '—' }}</div>
      </div>
    </ng-template>

    <ng-template #mainDropCell let-row>
      <div class="flex-row start-center gap-4">
        @if (row.mainStream?.drop !== null) {
          <span class="ui-icon-status-online"></span>
        }
        <div>{{ row.mainStream?.drop !== null ? ((row.mainStream?.drop | number : '1.0-0') + ' %') : '—' }}</div>
      </div>
    </ng-template>

    <ng-template #subBitrateCell let-row>
      <div class="flex-row start-center gap-4">
        @if (!row.substream?.resolution && !row.substream?.fps) {
          <div>—</div>
        } @else {
          @if (row.substream?.bitrate !== null) {
            <span class="ui-icon-status-online"></span>
          }
          <div>{{ row.substream?.bitrate !== null ? (row.substream?.bitrate | number : '1.0-1') : '—' }}</div>
        }
      </div>
    </ng-template>

    <ng-template #subDropCell let-row>
      <div class="flex-row start-center gap-4">
        @if (row.substream?.drop !== null) {
          <span class="ui-icon-status-online"></span>
        }
        <div>{{ row.substream?.drop !== null ? ((row.substream?.drop | number : '1.0-0') + ' %') : '—' }}</div>
      </div>
    </ng-template>
  </ui-dataset-table>
</div>
